<InactivityModal />

<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  ></Navbar>

  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <div class="col h-100 overflow-auto mt-2">
        <div class="visitor-card shadow border-primary">
          <div class="container-fluid px-0 pb-4">
            <div class="card-body bg-white pt-2">
              <div class="d-flex justify-content-between align-items-center sticky-top mb-4">
                <div></div>
              </div>

              <div v-if="is_loading" class="text-center py-5 w-100">
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 mb-0 text-muted text-xxs">Loading campaigns...</p>
              </div>

              <div v-else-if="campaigns.length">
                <div class="dashboard-stat-scroll">
                <div class="row g-3 mb-3">
                  <div class="col-6 col-md-6 col-xl-3">
                    <div class="visitor-card dashboard-stat-card h-100">
                      <div class="d-flex align-items-center gap-3 dashboard-stat-content h-100">
                        <div class="dashboard-stat-icon dashboard-stat-icon-primary">
                          <i class="bx bx-money"></i>
                        </div>
                        <div class="flex-grow-1 dashboard-stat-copy">
                          <div class="text-muted text-xxs mb-1">Total Raised</div>
                          <div class="dashboard-stat-value">{{ format_currency(total_raised_amount) }}</div>
                          <div class="text-xxs text-success">18.6% from last month</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 col-xl-3">
                    <div class="visitor-card dashboard-stat-card h-100">
                      <div class="d-flex align-items-center gap-3 dashboard-stat-content h-100">
                        <div class="dashboard-stat-icon dashboard-stat-icon-success">
                          <i class="bx bx-target-lock"></i>
                        </div>
                        <div class="flex-grow-1 dashboard-stat-copy">
                          <div class="text-muted text-xxs mb-1">Total Goal</div>
                          <div class="dashboard-stat-value">{{ format_currency(total_goal_amount) }}</div>
                          <div class="text-xxs text-muted">Overall campaign goals</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 col-xl-3">
                    <div class="visitor-card dashboard-stat-card h-100">
                      <div class="d-flex align-items-center gap-3 dashboard-stat-content h-100">
                        <div class="dashboard-stat-icon dashboard-stat-icon-purple">
                          <i class="bx bx-group"></i>
                        </div>
                        <div class="flex-grow-1 dashboard-stat-copy">
                          <div class="text-muted text-xxs mb-1">Total Donations</div>
                          <div class="dashboard-stat-value">{{ total_donations_count }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 col-md-6 col-xl-3">
                    <div class="visitor-card dashboard-stat-card h-100">
                      <div class="d-flex align-items-center gap-3 dashboard-stat-content h-100">
                        <div class="dashboard-stat-icon dashboard-stat-icon-warning">
                          <i class="bx bx-heart-circle"></i>
                        </div>
                        <div class="flex-grow-1 dashboard-stat-copy">
                          <div class="text-muted text-xxs mb-1">Active Campaigns</div>
                          <div class="dashboard-stat-value">{{ active_campaigns_count }}</div>
                          <div class="text-xxs text-muted">Currently running</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>

                <div class="table-responsive">
                <table id="campaignDashboardTable" class="table align-middle table-striped table-borderless w-100">
                  <thead class="text-uppercase btn-primary text-white">
                    <tr>
                      <th class="text-xxs fw-light text-center">No.</th>
                      <th class="text-xxs fw-light">Campaign Name</th>
                      <th class="text-xxs fw-light text-center">Category</th>
                      <th class="text-xxs fw-light text-center">Status</th>
                      <th class="text-xxs fw-light text-center">Raised</th>
                      <th class="text-xxs fw-light text-center">Goal</th>
                      <th class="text-xxs fw-light text-center">Donors</th>
                      <th class="text-xxs fw-light text-center">% Funded</th>
                      <th class="text-xxs fw-light text-center">Start Date</th>
                      <th class="text-xxs fw-light text-center">End Date</th>
                      <th class="text-xxs fw-light text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(campaign, index) in campaigns" :key="campaign.id" class="border-bottom text-xxs">
                      <td class="text-center">
                        <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                          {{ index + 1 }}
                        </span>
                      </td>
                      <td>
                        <div class="fw-bold text-dark">{{ campaign.name }}</div>
                      </td>
                      <td class="text-center">
                        <span class="chip chip-info text-xxs">
                          {{ campaign?.category?.name || "Uncategorized" }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge rounded-pill text-capitalize text-xxs fw-normal px-3 py-2"
                          :class="{
                            'bg-success-subtle text-success': String(campaign.status || '').toLowerCase() === 'active',
                            'bg-warning-subtle text-warning': String(campaign.status || '').toLowerCase() === 'paused',
                            'bg-info-subtle text-info': String(campaign.status || '').toLowerCase() === 'completed',
                            'bg-secondary-subtle text-secondary': !['active', 'paused', 'completed'].includes(String(campaign.status || '').toLowerCase()),
                          }"
                        >
                          {{ campaign.status || "draft" }}
                        </span>
                      </td>
                      <td class="text-center">{{ format_currency(get_campaign_raised_amount(campaign)) }}</td>
                      <td class="text-center">{{ format_currency(campaign.goal_amount) }}</td>
                      <td class="text-center">{{ get_campaign_donor_count(campaign) }}</td>
                      <td class="text-center">{{ get_progress(campaign) }}%</td>
                      <td class="text-center">{{ format_date(campaign.start_date) }}</td>
                      <td class="text-center">{{ format_date(campaign.end_date) }}</td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-light btn-sm rounded-3 text-primary border text-xxs px-3"
                          @click="open_campaign(campaign)"
                        >
                          Open
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>

              <div v-else class="text-center py-5 border rounded-3 bg-white">
                <i class="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                <div class="mb-1 text-xxs">No campaigns yet</div>
                <div class="small text-muted text-xxs">Campaigns will appear here once available.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
